<template>
    <app-signature
        v-bind="$attrs"
        :value="value"
        :label="field.title"
        :rules="rules"
        :required="required"
        v-on="$listeners" />
</template>

<script>
import formFieldMixin from "./formFieldMixin";
export default {
    types: [
        "signature"
    ],
    mixins: [formFieldMixin],
};
</script>
